import SelectInput, {Option} from "../atoms/SelectInput.tsx";
import {FC} from "react";
import useRandomId from "../helpers/useRandomId.ts";
import {Column} from "../atoms/Layout.tsx";
import InputLabel from "../atoms/InputLabel.tsx";
import InputHint from "../atoms/InputHint.tsx";

interface Props {
    label: string;
    hint?: string;
    value?: string;
    onChange?: (value: string) => void;
    options: Option[];
    error?: string;
    disabled?: boolean;
    placeholder?: string;
}

const SelectInputGroup: FC<Props> = ({
    label,
    hint,
    value,
    onChange,
    options,
    error,
    disabled,
    placeholder
}) => {
    const elementId = useRandomId();

    return <Column gap="8">
        <InputLabel for={elementId}>{label}</InputLabel>
        <SelectInput
            name={elementId}
            value={value}
            onChange={onChange}
            options={options}
            error={!!error}
            disabled={disabled}
            placeholder={placeholder} />
        { !error && hint && <InputHint>{hint}</InputHint> }
        { error && <InputHint error>{error}</InputHint> }
    </Column>
}

export default SelectInputGroup